import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const NAMES = ['Martín G.', 'Sofía R.', 'Luciana P.', 'Diego M.', 'Carolina F.', 'Nicolás A.', 'Valentina S.', 'Federico L.', 'Mariana T.', 'Joaquín B.', 'Agustina V.', 'Gonzalo D.', 'Florencia C.', 'Matías H.', 'Camila N.', 'Lucas P.', 'Julieta M.', 'Sebastián R.', 'Rocío E.', 'Tomás K.', 'Belén A.', 'Ignacio F.', 'Daniela O.', 'Franco G.', 'Micaela S.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche', 'Paraná', 'Posadas', 'San Juan', 'Resistencia', 'Bahía Blanca', 'Corrientes', 'Río Cuarto', 'Comodoro Rivadavia', 'Tandil'];
const OFFERS = [{
  name: 'Megapack Pro',
  price: '$29.990'
}, {
  name: 'Kit Pro',
  price: '$19.990'
}];
interface PurchaseEntry {
  name: string;
  city: string;
  offer: {
    name: string;
    price: string;
  };
  minutesAgo: number;
}
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function buildEntry(): PurchaseEntry {
  return {
    name: randomItem(NAMES),
    city: randomItem(CITIES),
    // Megapack appears more often (first item weighted)
    offer: Math.random() < 0.65 ? OFFERS[0] : OFFERS[1],
    minutesAgo: Math.floor(Math.random() * 8) // 0–7 min
  };
}
export function PurchasePopup() {
  const [entry, setEntry] = useState<PurchaseEntry | null>(null);
  const [visible, setVisible] = useState(false);
  const showNext = useCallback(() => {
    setEntry(buildEntry());
    setVisible(true);
    // hide after ~6s
    const hideTimer = setTimeout(() => setVisible(false), 6000);
    return hideTimer;
  }, []);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let loopTimer: ReturnType<typeof setTimeout>;
    const scheduleNext = (delay: number) => {
      loopTimer = setTimeout(() => {
        hideTimer = showNext();
        // schedule the following one 40–60s after this appears
        const nextDelay = 40000 + Math.random() * 20000;
        scheduleNext(nextDelay);
      }, delay);
    };
    // first popup after a short initial delay
    scheduleNext(5000);
    return () => {
      clearTimeout(loopTimer);
      clearTimeout(hideTimer);
    };
  }, [showNext]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[300px] sm:max-w-xs pointer-events-none" role="status" aria-live="polite" data-id="element-242">
      <AnimatePresence data-id="element-243">
        {visible && entry && <motion.div initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} className="pointer-events-auto bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-3.5 flex items-center gap-3 relative" data-id="element-244">
            <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute top-1.5 right-1.5 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-245">
              <XIcon className="w-3.5 h-3.5" data-id="element-246" />
            </button>

            <div className="bg-green-light/10 w-10 h-10 sm:w-11 sm:h-11 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-247">
              <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-green-light" strokeWidth={2} data-id="element-248" />
            </div>

            <div className="pr-3" data-id="element-249">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-250">
                <span className="text-[9px] sm:text-[10px] font-bold uppercase tracking-wider text-green" data-id="element-251">
                  Compra verificada
                </span>
              </div>
              <p className="text-[11px] sm:text-xs text-navy leading-snug" data-id="element-252">
                <strong className="font-bold" data-id="element-253">{entry.name}</strong> de{' '}
                <strong className="font-semibold" data-id="element-254">{entry.city}</strong> compró
                el <strong className="text-gold" data-id="element-255">{entry.offer.name}</strong>
              </p>
              <p className="text-[9px] sm:text-[10px] text-gray mt-0.5" data-id="element-256">
                {entry.minutesAgo === 0 ? 'Ahora mismo' : `Hace ${entry.minutesAgo} ${entry.minutesAgo === 1 ? 'minuto' : 'minutos'}`}{' '}
                · {entry.offer.price}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}